<template>
  <div class="data-page">
    <tooltipLine
      :tip="$store.state.language === 'en' ? require('@/assets/images/gd-en.png') : require('@/assets/images/gd.png')"
      :visible="!($store.state.user.hasBindData && $store.state.user.hasBindData.isExistCs)"
      :content="$t('work-order::auth_tooltip')"
    >
      <template slot="btn">
        <span class="bind-btn" @click="onSetEmail">{{ $t('user-guidance::guide::email_button') }}</span>
      </template>
    </tooltipLine>
    <el-row type="flex" justify="space-between">
      <el-col :xl="16" :lg="14" :md="12" :sm="10" :xs="24" style="display:flex;align-items:center;">
        <label style="width:70px;">{{ $t('work-order::shopName') }}</label>
        <el-select v-model="selectedShop" :placeholder="$t('system::common::select_placeholder')" @change="changeShop">
          <el-option
            v-for="item in shopList"
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xl="8" :lg="10" :md="12" :sm="14" :xs="24" style="display:flex;align-items:center;">
        <label style="width:150px;">{{ $t('work-order::recieveDate') }}</label>
        <el-date-picker
          style="width: 100%"
          :clearable="false"
          @change="handlerDateChange"
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          :range-separator="$t('system::time::text::include')"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button style="margin-left: 8px;" @click="$router.push({ path: reportJumpUrl().workOrderAnalysis })">
          {{ $t('system::common::btn::check_report') }}
        </el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="card-content">
      <el-col :lg="6" :md="6" :sm="12" :xl="6" v-for="(item, index) in cardOptions" :key="index" class="card-item">
        <dataCard :option="item" v-loading="loading.card"></dataCard>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="acceptEmailConfig"
          v-loading="loading.acceptEmail"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>

      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="emailTypeConfig"
          v-loading="loading.emailType"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportTable :config="replierConfig" v-loading="loading.replier" :style="`height: ${reportHeight};`">
          <template slot="other">
            <el-button :type="active === 'people' ? 'primary' : ''" @click="changeReplyType('people')">
              {{ $t('work-order::replier::table') }}
            </el-button>
            <el-button :type="active === 'pointer' ? 'primary' : ''" @click="changeReplyType('pointer')">
              {{ $t('work-order::station') }}
            </el-button>
          </template>
          <el-table-column
            prop="responsePersonName"
            :label="active === 'people' ? $t('work-order::replier::table_name') : $t('work-order::station::table_name')"
            min-width="125px"
            showOverflowTooltip
          ></el-table-column>
          <el-table-column
            prop="recieveEmails"
            :label="$t('work-order::replier::table_email')"
            min-width="125px"
          ></el-table-column>
          <el-table-column
            prop="unresponseNum"
            :label="$t('work-order::replier::table_notReply')"
            min-width="125px"
          ></el-table-column>
          <el-table-column
            prop="responseNum"
            :label="$t('work-order::replier::table_reply')"
            min-width="125px"
          ></el-table-column>
          <el-table-column
            prop="12HourResponseNum"
            :label="$t('work-order::replier::table_12reply')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="1224HourResponseNum"
            :label="$t('work-order::replier::table_24reply')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="2448HourResponseNum"
            :label="$t('work-order::replier::table_48reply')"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            prop="48OverHourResponseNum"
            :label="$t('work-order::replier::table_out48reply')"
            min-width="180px"
          ></el-table-column>
        </reportTable>
      </el-col>
    </el-row>
    <emailModal v-model="drawerVisable" @save="onSave" :drawRow="drawRow"></emailModal>
  </div>
</template>

<script>
import moment from 'moment'
import emailModal from '@/views/after-sales/components/email-modal'
import { pickerOptions } from '@/utils/datepickerConfig'
import { getWorkOrderCount, getEmailLineCharts, getEmailTypePieCharts, getEmailReplyTable } from '@/server/data'
import { getShopList } from '@/server/product'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import { reportJumpUrl } from '@/utils/config'

export default {
  name: 'work-order',
  components: {
    emailModal,
    dataCard,
    reportCard,
    reportTable
  },
  mixins: [setConfig],
  data() {
    return {
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        }
      },
      active: 'people',
      date: [moment().subtract(29, 'days'), moment()],
      params: {
        startDate: moment()
          .subtract(29, 'days')
          .format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      selectedShop: '',
      drawRow: {
        type: 'add',
        item: {}
      },
      drawerVisable: false,
      shopList: [{ shopName: this.$t('system::common::select_all'), shopId: '' }],
      cardOptions: {},
      reportHeight: '400px',
      replierConfig: {},
      acceptEmailConfig: {},
      emailTypeConfig: {},
      cardLoading: false,
      loading: {
        card: false,
        acceptEmail: false,
        emailType: false,
        replier: false
      }
    }
  },
  async mounted() {
    this.cardOptions = this.setCountList({})
    await this.getShopData()
    this.getAllData()
  },
  methods: {
    reportJumpUrl,
    async getShopData() {
      const { data } = await getShopList()
      if (data.code === this.$code && data.data) {
        this.shopList = [...this.shopList, ...data.data]
      }
    },
    getAllData() {
      this.getCount()
      this.getEmailLineChart()
      this.getEmailPieChart()
      this.getEmailTable()
    },
    async onSave() {
      this.cardOptions = this.setCountList({})
      await this.getShopData()
      this.getAllData()
    },
    changeShop() {
      console.log(this.params)
      this.getAllData()
    },
    // 获取汇总数据
    async getCount() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.card = true
      const { data } = await getWorkOrderCount(obj)
      this.cardOptions = this.setCountList(data.data.datas[0] || {})
      this.loading.card = false
    },
    // 获取收到邮件数折线图
    async getEmailLineChart() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.acceptEmail = true
      const { data } = await getEmailLineCharts(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.acceptEmailConfig = this.setAcceptEmailConfig(list)
      this.loading.acceptEmail = false
    },
    // 获取收到邮件类型占比图
    async getEmailPieChart() {
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.emailType = true
      const { data } = await getEmailTypePieCharts(obj)
      const list = Array.isArray(data.data.datas) ? data.data.datas : []
      this.emailTypeConfig = this.setEmailTypeConfig(list)
      this.loading.emailType = false
    },
    // 获取邮件详情表格
    async getEmailTable() {
      let obj = {
        demension: this.active,
        ...this.params
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.replier = true
      const { data } = await getEmailReplyTable(obj)
      this.replierConfig = this.setReplierConfig(data.data.datas)
      this.loading.replier = false
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getAllData()
    },
    changeReplyType(type) {
      if (type === this.active) {
        return
      }
      this.active = type
      this.getEmailTable()
    },
    onSetEmail() {
      this.drawerVisable = true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  margin-top: 10px;
}
.date-label {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
